export interface FamilyMember {
  id: string
  name: string
  birthYear: string
  deathYear?: string
  x: number
  y: number
  parents?: string[]
  avatar: string
  bio: string
  voiceNote?: {
    title: string
    duration: string
  }
  photos: string[]
}

export const familyData: FamilyMember[] = [
  {
    id: '1',
    name: 'Amma (Lakshmi)',
    birthYear: '1934',
    x: 400,
    y: 150,
    avatar:
      'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&q=80&w=300&h=300',
    bio: 'Immigrated from Kerala in 1962. She carried the scent of cardamom and coconut oil wherever she went. Loved cooking and telling ghost stories.',
    voiceNote: {
      title: "Grandma's story about the monsoon",
      duration: '2:34',
    },
    photos: [
      'https://images.unsplash.com/photo-1596450514735-111a2fe02935?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1506869640319-baa173305ad3?auto=format&fit=crop&q=80&w=400',
      'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&q=80&w=400',
    ],
  },
  {
    id: '2',
    name: 'Appa (Krishnan)',
    birthYear: '1930',
    deathYear: '2015',
    x: 600,
    y: 150,
    avatar:
      'https://images.unsplash.com/photo-1532073150508-0c1df0221c21?auto=format&fit=crop&q=80&w=300&h=300',
    bio: 'A quiet man who spoke mostly through his garden. He grew the best mangoes in the neighborhood and always kept a diary in his chest pocket.',
    photos: [
      'https://images.unsplash.com/photo-1416879572646-01ed52c1015b?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1585314062340-f1a5a7c9328d?auto=format&fit=crop&q=80&w=400',
      'https://images.unsplash.com/photo-1444858291040-58f756a3bdd6?auto=format&fit=crop&q=80&w=400',
    ],
  },
  {
    id: '3',
    name: 'Priya',
    birthYear: '1965',
    x: 350,
    y: 400,
    parents: ['1', '2'],
    avatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=300&h=300',
    bio: "The anchor of the family. She inherited Amma's laugh and Appa's patience. Runs a small bakery downtown.",
    voiceNote: {
      title: 'Singing the morning lullaby',
      duration: '1:15',
    },
    photos: [
      'https://images.unsplash.com/photo-1555243896-c709bfa0b564?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1509305717900-84f40e786d82?auto=format&fit=crop&q=80&w=400',
      'https://images.unsplash.com/photo-1517365830460-955ce3ccd263?auto=format&fit=crop&q=80&w=400',
    ],
  },
  {
    id: '4',
    name: 'Arun',
    birthYear: '1962',
    x: 150,
    y: 400,
    avatar:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=300&h=300',
    bio: "Always has a camera around his neck. Met Priya at a train station in 1988 and they've been traveling together ever since.",
    photos: [
      'https://images.unsplash.com/photo-1516961642265-531546e84af2?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1469334031218-e382a71b716b?auto=format&fit=crop&q=80&w=400',
      'https://images.unsplash.com/photo-1452421822248-d4c2b47f0c81?auto=format&fit=crop&q=80&w=400',
    ],
  },
  {
    id: '5',
    name: 'Raj',
    birthYear: '1968',
    x: 750,
    y: 400,
    parents: ['1', '2'],
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=300&h=300',
    bio: 'The youngest and the rebel. Moved to the city to play music, now teaches classical guitar to kids.',
    photos: [
      'https://images.unsplash.com/photo-1511379938547-c1f69419868d?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1485579149621-3123dd979885?auto=format&fit=crop&q=80&w=400',
      'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&q=80&w=400',
    ],
  },
  {
    id: '6',
    name: 'Me (Rohan)',
    birthYear: '1992',
    x: 150,
    y: 650,
    parents: ['3', '4'],
    avatar:
      'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&q=80&w=300&h=300',
    bio: "Software designer by day, amateur chef by night. Trying to perfect Amma's fish curry recipe.",
    photos: [
      'https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1498837167922-41c53b4f0f02?auto=format&fit=crop&q=80&w=400',
      'https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&q=80&w=400',
    ],
  },
  {
    id: '7',
    name: 'Maya',
    birthYear: '1995',
    x: 350,
    y: 650,
    parents: ['3', '4'],
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=300&h=300',
    bio: "Environmental scientist. Spends most of her time in forests. Has Appa's green thumb but on a much larger scale.",
    voiceNote: {
      title: 'Bird sounds from the Amazon',
      duration: '0:45',
    },
    photos: [
      'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&q=80&w=400',
      'https://images.unsplash.com/photo-1472396961693-142e6e269027?auto=format&fit=crop&q=80&w=400',
    ],
  },
  {
    id: '8',
    name: 'Kiran',
    birthYear: '1998',
    x: 750,
    y: 650,
    parents: ['5'],
    avatar:
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&q=80&w=300&h=300',
    bio: 'Art student in London. Paints large, vibrant canvases that look exactly like the stories Amma used to tell.',
    photos: [
      'https://images.unsplash.com/photo-1513364776144-60967b0f800f?auto=format&fit=crop&q=80&w=600',
      'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&q=80&w=400',
      'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?auto=format&fit=crop&q=80&w=400',
    ],
  },
]
